"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _rcTooltip = _interopRequireDefault(require("rc-tooltip"));

var _overrides = require("../../../utils/overrides");

var _styles = require("../../../utils/styles");

var _styles2 = _interopRequireDefault(require("./styles"));

var useStyles = (0, _styles.createUseStyles)(_styles2.default, 'Tooltip');

function Tooltip(_ref) {
  var children = _ref.children,
      classesProp = _ref.classes,
      overridesProp = _ref.overrides,
      classNameProp = _ref.className,
      content = _ref.content,
      placement = _ref.placement,
      props = (0, _objectWithoutProperties2.default)(_ref, ["children", "classes", "overrides", "className", "content", "placement"]);
  var classes = (0, _overrides.useClasses)(useStyles, classesProp); // Overrides

  var override = (0, _overrides.getOverrides)(overridesProp, Tooltip.overrides); // Classes

  var rootClassName = (0, _classnames.default)(classes.root, classNameProp);
  var rootProps = {
    prefixCls: 'hoi-poi-tooltip',
    transitionName: 'hoi-poi-tooltip--fade',
    trigger: ['hover'],
    overlayClassName: rootClassName,
    overlay: content,
    placement: placement
  };
  if (content === undefined || content === null) return children;
  return /*#__PURE__*/_react.default.createElement(_rcTooltip.default, (0, _extends2.default)({}, rootProps, override.root), children);
}

Tooltip.overrides = ['root'];
Tooltip.defaultProps = {
  overrides: {},
  placement: 'top'
};
process.env.NODE_ENV !== "production" ? Tooltip.propTypes = {
  className: _propTypes.default.string,
  overrides: _propTypes.default.object,
  content: _propTypes.default.any,
  placement: _propTypes.default.oneOf(['top', 'topLeft', 'topRight', 'bottom', 'bottomLeft', 'bottomRight', 'left', 'leftTop', 'leftBottom', 'right', 'rightTop', 'rightBottom'])
} : void 0;

var _default = /*#__PURE__*/_react.default.memo(Tooltip);

exports.default = _default;